import 'jquery';
import { $window, $body, Breakpoints } from '../Constants';
import HtmlElement from './HtmlElement';
import NavSubHorizontal from './NavSubHorizontal';

/**
 * CtaBar
 */
const CtaBar = (($) => {
	// Constants
	const DATA_KEY = 'ig.cta-bar';
	const EVENT_KEY = `.${DATA_KEY}`;
	const SCROLL_THRESHOLD = 1;
	const REPOSITION_BREAKPOINT = Breakpoints.X_LARGE;
	const TRANSITION_DURATION = 250;

	/**
	 * States
	 */
	const States = {
		TOP: 'top',
		BOTTOM: 'bottom'
	};

	/**
	 * Selector
	 */
	const Selector = {
		CTA_BAR: '.cta-bar'
	};

	/**
   * ClassName
   */
	const ClassName = {
	  HIDDEN: 'hidden',
    VISIBLE: 'visible'
  };

	/**
	 * Event
	 */
	const Event = {
		SCROLL: `scroll${EVENT_KEY}`,
    RESIZE: `resize${EVENT_KEY}`
	};

	/**
	 * CtaBar
	 *
	 * @class
   * @augments HtmlElement
	 */
	class CtaBar extends HtmlElement {
		// Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._$targetTop = $body.find('.cta-bar-container');
      this._$targetBottom = $body.find('#header');
      this._currentState = States.TOP;

      if (!this.$element.hasClass('only-top')) {
        this._bindHandlers();
        this._handleState();
      }
    }

		// Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        this._handleState();
      });

      $window.on(Event.SCROLL, () => {
        this._handleState();
      });
    }

    /**
     * Checks the current state and returns it
     *
     * @return { String } state
     */
    _checkState() {
      let state = States.TOP;

      if ($window.width() >= REPOSITION_BREAKPOINT) {
        state = States.BOTTOM;

        if ($window.scrollTop() >= SCROLL_THRESHOLD) {
          state = States.TOP;
        }
      }

      return state;
    }

		/**
		 * Handles the reposition state
		 *
		 * @return void
		 */
		_handleState() {
		  let state = this._checkState();

		  switch (state) {
        case States.TOP:
          this._insertTop();
          break;

        case States.BOTTOM:
          this._insertBottom();
          break;
      }

      this._currentState = state;
		}

		/**
		 * Removes the element from the header, inserts in meta bar
		 *
		 * @return void
		 */
		_insertTop() {
			if (this._currentState !== States.TOP) {
			  this._$element.removeClass(ClassName.VISIBLE);

			  setTimeout(() => {
          this._$element.appendTo(this._$targetTop);

          if (NavSubHorizontal.exists()) {
            NavSubHorizontal.updateScrolledAt();
            NavSubHorizontal.adjustTopValue();
          }

          setTimeout(() => {
            this._$element.addClass(ClassName.VISIBLE);
          }, 50);
        }, TRANSITION_DURATION);
			}
		}

		/**
		 * Removes the element from the meta bar, inserts in header
		 *
		 * @return void
		 */
		_insertBottom() {
			if (this._currentState !== States.BOTTOM) {
        this._$element.removeClass(ClassName.VISIBLE);

        setTimeout(() => {
          this._$element.appendTo(this._$targetBottom);

          setTimeout(() => {
            this._$element.addClass(ClassName.VISIBLE);
          }, 50);
        }, TRANSITION_DURATION);
			}
		}
	}

	return CtaBar._getElement($body.find(Selector.CTA_BAR), CtaBar);
})(jQuery);

export default CtaBar;
